import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { constants } from "@qgiv/core-js";
import { selectIsCms } from "../../../../redux/slices/configSlice";
import { selectCmsControlByIdByPage } from "../../../../redux/slices/cmsSettingsSlice";
import AddAdditionalParticipantButton from "./AddAdditionalParticipantButton";

const ConnectedAddAdditionalParticipantButton = ({
    controlId,
    additionalParticipantsDisabled,
    handleFormSubmitWithEmailValidation,
}) => {
    const { values, setFieldValue, submitForm } = useFormikContext();
    const { Is_Nfp } = values;
    const {
        ENUMS: { DefaultView },
    } = constants;
    const isCms = useSelector(selectIsCms);
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_DETAILS_STEP,
            state,
        ),
    );

    const {
        options: { addParticipantButtonLabel },
    } = control;

    const addAdditionalParticipantButtonProps = {
        addParticipantButtonLabel,
        additionalParticipantsDisabled,
        isCms,
        Is_Nfp,
        setFieldValue,
        submitForm,
        handleFormSubmitWithEmailValidation,
    };

    return (
        <AddAdditionalParticipantButton
            {...addAdditionalParticipantButtonProps}
        />
    );
};

ConnectedAddAdditionalParticipantButton.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    additionalParticipantsDisabled: PropTypes.bool.isRequired,
    handleFormSubmitWithEmailValidation: PropTypes.func.isRequired,
};

export default ConnectedAddAdditionalParticipantButton;
